import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import images from "../../assets/images";
import { useGetContentQuery } from "../../redux/Apis/Content";

const TrustedSection = () => {
  const lang = useSelector((state) => state.language.lang);
  const {
    data: preview,
    isLoading: isPreviewLoading,
    refetch: refetchPreview,
  } = useGetContentQuery({
    search: "preview",
    lang,
  });

  useEffect(() => {
    refetchPreview();
  }, []);

  return (
    <section className="trusted-by py-sm-5 py-4">
      <div className="container">
        <div className="row">
          <div className="col-xxl-10 col-xl-11 col-12 mx-auto">
            {isPreviewLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner style={{ color: "var(--primaryColor)" }} />
              </div>
            ) : (
              <div className="row align-items-center">
                <div className="col-lg-6 my-3">
                  <div className="position-relative text-end">
                    {preview?.data?.sections?.[0]?.url ? (
                      <a
                        href={preview.data.sections[0].url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={preview.data.sections[0].image}
                          alt="Preview"
                          className="img-fluid"
                          style={{ borderRadius: "1rem", cursor: "pointer" }}
                        />
                      </a>
                    ) : (
                      <img
                        src={images.home.preview_course}
                        alt="Preview"
                        className="img-fluid"
                        style={{ borderRadius: "1rem" }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-6 my-3 ps-xl-5">
                  <h2 className="text-uppercase mt-3">
                    {preview?.data?.sections?.[0]?.title ||
                      "Preview Our Top Courses/Tracks"}
                  </h2>
                  <div
                    className="mt-2"
                    dangerouslySetInnerHTML={{
                      __html: preview?.data?.sections?.[0]?.content || "",
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
